import React from "react";
import { graphql } from "gatsby";

import { HeroBlock } from "../components/hero";
import SEO from "../components/seo/head";

import ExpertAcademyIntroduction from "../components/expert-academy/intro";

const ExpertAcademyTrainingPage = ({ data }) => {
    const { hero } = data?.contentfulExpertAcademyTrainingPage;

    return (
        <>
            <HeroBlock {...hero} />
            <ExpertAcademyIntroduction {...data?.contentfulExpertAcademyTrainingPage} />
        </>
    );
}

export const Head = ({ data, location }) => (
    <SEO
        location={location}
        {...data.contentfulExpertAcademyTrainingPage?.seo} 
    />
);

export default ExpertAcademyTrainingPage;

export const ExpertAcademyQuery = graphql`
    query ($id: String) {
        contentfulExpertAcademyTrainingPage(id: {eq: $id}) {
            seo {
                metaTitle
                metaDescription {
                    metaDescription
                }
                robotsMetaTag
            }
            backgroundColour
            textColour
            hero {
                ...heroBlockFields
            }
            mainTitle
            mainSubtitle
            mainText {
                raw
            }
            mainSupportingImage {
                gatsbyImageData(
                    width: 1920
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                )
            }
            button {
                openInANewTab
                text
                url
            }
            secondaryTitle
            secondaryContent {
                raw
            }
            secondarySupportingImages {
                gatsbyImageData(
                    width: 500
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                )
            }
            secondaryCtaButton {
                openInANewTab
                text
                url
            }
            bottomBanner {
                backgroundImage {
                    file {
                        url
                    }
                }
                ctaLink
            }
            relatedBlogPosts {
                title
                slug
                description {
                    description
                }
                categories{
                    title
                    slug
                }
                publishDate
            image {
                gatsbyImageData(
                width: 1920
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                )
                title
            }
            metaTitle
                metaDescription {
                    metaDescription
                }
            robotsMetaTag
            
        }
}
    }
`;